export const favorites = {
  title: "I miei preferiti",
  subtitle: "{{count}} alloggi salvati",
  countries: "Paesi",
  cities: "Città",
  emptyTitle: "Nessun preferito per il momento",
  emptyFiltered:
    "Prova a modificare i tuoi filtri per vedere i tuoi preferiti.",
  emptyState:
    "Esplora i nostri alloggi unici e aggiungili ai preferiti per ritrovarli qui.",
  noFavoritesYet: "Nessun preferito per il momento",
  exploreMembersMap: "Esplora la mappa dei membri per trovare alloggi",
  exploreMap: "Esplora la mappa",
  backToHome: "Torna alla pagina iniziale",
  howToAddFavorites: "Come aggiungere preferiti?",
  step1: "Vai sulla",
  step2: "mappa dei membri",
  step3: "e clicca sul cuore",
  step3End: "per aggiungere un alloggio ai tuoi preferiti",
  membersMapLink: "Mappa dei membri",
  properties: "proprietà",
  selected: "selezionate",
  compare: "Confronta",
  actions: "Azioni",
  contact: "Contatta",
  exchange: "Proponi uno scambio",
  removeFromFavorites: "Rimuovi dai preferiti",
  removeFromComparison: "Rimuovi dal confronto",
  owner: "Proprietario",
  ratingLabel: "Voto",
  exchangesLabel: "Scambi",
  exchangesCount: "scambi",
  exchangesCompleted: "scambi realizzati",
  capacityLabel: "Capacità",
  guestsCount: "viaggiatori",
  numberOfRooms: "camere",
  roomsCount: "camere",
  onlineStatus: "In linea",
  onlineBadge: "In linea",
  verifiedStatus: "Verificato",
  verifiedBadge: "Verificato",
  no: "No",
};
